import { Icon } from '../icons';
import { OwlLogo } from '../shared';
import type { MobileShellCtx } from './MobileShellCtx';
import { RANGE_OPTIONS, routeTitle } from './MobileShellCtx';

export function MobileTopBar({ ctx }: { ctx: MobileShellCtx }) {
  const { route } = ctx;
  const isOverview = route.name === 'overview';
  const showRange = route.name === 'overview' || route.name === 'apps';
  const crumb = routeTitle(route);

  return (
    <header className="m-topbar">
      <div className="m-crumbs">
        <OwlLogo size={14} />
        OWL
        <span className="sep">/</span>
        <strong>{crumb}</strong>
        <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
          <fieldset className="env-switch" aria-label="Environment">
            <button
              type="button"
              className={`env-opt dev ${ctx.environment === 'development' ? 'active' : ''}`}
              onClick={() => ctx.setEnvironment('development')}
            >
              {ctx.environment === 'development' && <span className="env-dot" />} DEV
            </button>
            <button
              type="button"
              className={`env-opt prod ${ctx.environment === 'production' ? 'active' : ''}`}
              onClick={() => ctx.setEnvironment('production')}
            >
              {ctx.environment === 'production' && <span className="env-dot" />} PROD
            </button>
          </fieldset>
        </span>
      </div>

      <div className="m-topbar-main">
        {isOverview ? (
          <div className="owl-brand">
            <div className="owl-brand-mark">
              <OwlLogo size={28} />
            </div>
            <div className="owl-brand-text">
              <div className="owl-brand-word">OWL</div>
              <div className="owl-brand-tag">Observe · Warn · Log</div>
            </div>
          </div>
        ) : (
          <h1 className="m-title">{crumb}</h1>
        )}
        <div className="m-actions">
          <button
            type="button"
            className="m-iconbtn"
            onClick={() => ctx.openSheet({ kind: 'search' })}
            aria-label="Buscar"
          >
            <Icon.Search size={15} />
          </button>
          <button
            type="button"
            className={`m-iconbtn ${ctx.liveConnected ? 'live' : ''}`}
            onClick={() => {
              ctx.resetUnreadAlerts();
              ctx.navigate({ name: 'alerts', tab: 'events' });
            }}
            aria-label="Alertas"
          >
            <Icon.Bell size={15} />
            {ctx.unreadAlerts > 0 && (
              <span className="badge">{ctx.unreadAlerts > 9 ? '9+' : ctx.unreadAlerts}</span>
            )}
          </button>
        </div>
      </div>

      {isOverview && (
        <div className="mode-seg">
          <button
            type="button"
            className={ctx.viewMode === 'logs' ? 'active' : ''}
            onClick={() => ctx.setViewMode('logs')}
          >
            <Icon.Activity size={14} /> Logs
          </button>
          <button
            type="button"
            className={ctx.viewMode === 'ai' ? 'active ai' : ''}
            onClick={() => ctx.setViewMode('ai')}
          >
            <Icon.Cable size={14} /> AI Usage
          </button>
        </div>
      )}

      {showRange && (
        <div className="m-range-row">
          {RANGE_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`m-range-chip ${ctx.range === opt.value ? 'active' : ''}`}
              onClick={() => ctx.setRange(opt.value)}
            >
              {opt.label}
            </button>
          ))}
          <button
            type="button"
            className="m-range-chip"
            style={{ marginLeft: 'auto' }}
            onClick={ctx.triggerRefresh}
            aria-label="Refrescar"
            title="Refrescar"
          >
            <Icon.Refresh size={11} />
          </button>
        </div>
      )}
    </header>
  );
}
